<template>
  <div>
    <v-card class="mx-auto" elevation="0">
      <v-card-title class="text-left card-header fixed-card-title2">{{ $t('assign-licence-to-patient') }}
        <v-spacer></v-spacer>
        <v-icon class="white--text float-end mr-1" @click="closeDrawer">mdi-close</v-icon>
      </v-card-title>
    </v-card>
    <v-container>
      <v-card>
        <v-data-table
          :no-data-text="$t('no-data-available')"
          :loading-text="$t('loading')"
          :loading="loading"
          hide-default-footer
          :items-per-page="-1"
          fixed-header
          :height="pageHeight(170)"
          :headers="headers"
          :items="filteredLicences"
        >
          <template v-slot:item="{item}">
            <tr @click="selectedLicenceRow(item)">
              <td class="text-left font-size12 font-weight-medium">{{item?.licenseName}}</td>
              <td class="text-left font-size12-5 font-weight-medium">{{item?.licenseDescription}}</td>
              <td class="text-left font-size12-5 font-weight-medium">{{item?.price}}</td>
              <td>
                <v-radio-group hide-details  v-model="selectedLicenceForPatient">
                <v-radio class="mt-n5" :value="item.id"></v-radio>
              </v-radio-group>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-card-actions class="fixed-card-actions">
      <v-row class="mb-0">
        <v-col cols="6">
          <v-btn
              @click="closeDrawer"
              elevation="0"
              class="cancel-button-style capitalize-text"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              :disabled="!selectedLicenceForPatient"
              @click="save"
              class="save-button-style"
          >
            {{ $t("save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </div>
<!--  Implement here the Endpoint for the licences , to take all of the licences and to render them so that we can assign the ID from the licence to the patient .-->
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { showSuccessAlert } from '@/utils/utilities';

export default {
  name: 'AddLicenceForPatientDrawer.vue',
  data () {
    return {
      selectedLicenceForPatient: null,
      loading: false,
    };
  },
  methods: {
    async getPatients () {
      this.loading = true;
      await this.$store.dispatch('hospitals/getRelatedPatientsV4', this.userData.hospitalAssignedData.id)
          .then(() => {
            this.loading = false;
          });
    },
    // MAKE A FUNCTION TO CALL AND ENDPOINT.
    async save () {
      try {
        const body = {
          licenseId: this.selectedLicenceForPatient,
          patientUserId: this.patientData.id,
        };
        this.$store.dispatch('licenses/assignLicenseForPatient', body).then(res => {
          this.getPatients();
          showSuccessAlert(res.msg);
          this.closeDrawer();
        });
      } catch (error) {
        return error;
      }
    },
    selectedLicenceRow (item) {
      this.selectedLicenceForPatient = item.id;
    },
    closeDrawer () {
      this.$store.commit('SET_DETAILS_DRAWER', false);
    },
    getLicences () {
      this.loading = true;
      this.$store.dispatch('licenses/getLicenses').then(res => {
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapState({
      licenses: state => state.licenses.licenses,
      patientData: state => state.item,
      userData: (state) => state.authentication.userData,
    }),
    ...mapGetters({
      pageHeight: 'pageHeight',
    }),
    filteredLicences () {
      return this.licenses.filter(licence => licence.isLicenseAssigned === false && licence.isActive === true);
    },
    //   Render only the NOT assigned Licenses make a computed property.

    headers () {
      const headers = [
        {
          text: this.$t('license-name'),
          value: 'licenseName',
          class: 'table-header px-0 mx-0',
          align: 'start',
          id: 1,
        },
        {
          text: this.$t('license-description'),
          class: 'table-header',
          align: 'start',
          value: 'licenseName',
          id: 4,
        },
        {
          text: this.$t('price'),
          class: 'table-header',
          align: 'start',
          value: 'price',
          sortable: false,
          id: 8,
        },
        {
          text: this.$t('Assign'),
          class: 'table-header',
          align: 'start',
          value: 'price',
          sortable: false,
          id: 9,
        },
      ];
      return headers;
    },
  },
   mounted () {
     this.getLicences();
  },
};
</script>
